<template>
  <v-card class="mx-auto bborder">
    <v-toolbar
      class="mb-3 d-flex justify-space-around"
      height="70px"
      color="orange darken-2"
      elevation="0"
    >
      <h1 class="">{{ $t("english_graduate.title") }}</h1>
    </v-toolbar>
    <v-card width="95%" class="mx-auto pa-2" elevation="0">
      <v-row>
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.student_id") }} :
          <b>{{ student_id }}</b></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.name") }} :
          <b>{{ inlineTranslator({ en: fname_en, th: fname_th }) }}</b></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.surname") }} :
          <b>{{ inlineTranslator({ en: lname_en, th: lname_th }) }}</b></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.admis_year") }} :
          <b
            >{{ admis_term }} /
            {{ inlineTranslator({ en: admis_year_en, th: admis_year }) }}</b
          ></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.level") }} :
          <b>{{
            inlineTranslator({ en: level_name_en, th: level_name_th })
          }}</b></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.curriculum_type") }} :
          <b>{{
            inlineTranslator({ en: curr_etype, th: curr_type })
          }}</b></v-col
        >
        <v-col md="4" sm="6" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.faculty") }} :
          <b>{{
            inlineTranslator({ en: faculty_ename, th: faculty_name })
          }}</b></v-col
        >
        <v-col md="8" sm="12" cols="12" class="text-left pl-sm-6 py-1"
          >{{ $t("english_graduate.curriculum") }} :
          <b>{{
            inlineTranslator({ en: curr_ename, th: curr_tname })
          }}</b></v-col
        ></v-row
      >
    </v-card>
    <v-card width="95%" class="mx-auto mt-4 tborder" elevation="2">
      <p class="text-left imtext pt-5 pl-2 pl-sm-6">
        <b>{{ $t("english_graduate.english_status") }}</b> :
        <span :style="{ color: getPassColor() }"
          ><b
            ><u>{{ inlineTranslator({ en: e_type_en, th: e_type_th }) }}</u></b
          ></span
        >
      </p>
      <h3 v-if="e_subject_count" class="text-left pl-2 pl-sm-6">
        {{ $t("english_graduate.english_subject") }} : {{ e_subject_pass }}
      </h3>
      <h5 class="text-left pt-8 pl-2 pl-sm-6">
        <a
          :href="
            inlineTranslator({
              en: getEnglishLink('en'),
              th: getEnglishLink('th'),
            })
          "
          target="_blank"
          ><v-btn small color="info" outlined>{{
            $t("english_graduate.check_english")
          }}</v-btn></a
        >
      </h5>
      <h5 class="text-center red--text pt-4 pb-4" v-if="level == 3">
        <v-icon color="red">mdi-alert</v-icon>
        {{ $t("english_graduate.level") }}
        <u>{{ inlineTranslator({ en: level_name_en, th: level_name_th }) }}</u>
        {{ $t("english_graduate.doctor_warning") }}
      </h5>
      <h5 class="text-left gtext pl-2 pl-sm-6 pt-4 pb-4" v-if="level == 2">
        <v-icon color="black">mdi-message-alert</v-icon>
        {{ $t("english_graduate.master_warning") }}
      </h5>
    </v-card>
    <p class="pt-4 text-center grey--text">
      Copyright © 2024. Developed by IT KRESO. Supported by Graduate Section of
      KRESO.
    </p>
    <v-card width="95%" class="mx-auto" elevation="0">
      <h5 class="text-left">{{ $t("english_graduate.english_history") }}</h5>
      <v-simple-table class="pb-5">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">{{ $t("english_graduate.times") }}</th>
              <th class="text-center">
                {{ $t("english_graduate.append_date") }}
              </th>
              <th class="text-center">{{ $t("english_graduate.criteria") }}</th>
              <th class="text-center">
                {{ $t("english_graduate.exam_type") }}
              </th>
              <th class="text-center">
                {{ $t("english_graduate.check_status") }}
              </th>
              <th class="text-center">
                {{ $t("english_graduate.approved_date") }}
              </th>
              <th v-if="is_acl_authorized_officer" class="text-center">
                รายละเอียด
              </th>
            </tr>
          </thead>
          <tbody v-if="record !== null" class="text-center">
            <tr v-for="(item, index) in record" :key="index">
              <td class="greattable">{{ item.version }}</td>
              <td class="greattable" v-html="dt(item.created_at)"></td>
              <td class="greattable">
                <div v-if="item.study === '0'">
                  {{
                    inlineTranslator({
                      en: study_type_en.zero,
                      th: study_type_th.zero,
                    })
                  }}
                </div>
                <div v-if="item.study === '1'">
                  {{
                    inlineTranslator({
                      en: study_type_en.one,
                      th: study_type_th.one,
                    })
                  }}
                </div>
                <div v-if="item.study === '2'">
                  {{
                    inlineTranslator({
                      en: study_type_en.two,
                      th: study_type_th.two,
                    })
                  }}
                </div>
              </td>
              <td class="greattable">{{ item.exam_type }}</td>
              <td class="greattable">
                <v-chip v-if="item.status_id === '1'" color="amber lighten-1"
                  ><v-icon left color="amber lighten-5">
                    mdi-dots-horizontal-circle</v-icon
                  >{{
                    inlineTranslator({
                      en: pass_result_en.one,
                      th: pass_result_th.one,
                    })
                  }}</v-chip
                >
                <v-chip
                  v-if="item.status_id === '3'"
                  color="red"
                  label
                  @click="openDialog(item)"
                  ><v-icon left color="red lighten-4"> mdi-close-circle </v-icon
                  >{{
                    inlineTranslator({
                      en: pass_result_en.three,
                      th: pass_result_th.three,
                    })
                  }}</v-chip
                >
                <v-dialog v-model="dialog" max-width="350">
                  <v-card>
                    <v-card-title class="headline">{{
                      inlineTranslator({
                        en: pass_result_en.three,
                        th: pass_result_th.three,
                      })
                    }}</v-card-title>
                    <v-card-text
                      ><b>{{ selectedItem?.comment }}</b></v-card-text
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="warning" @click="dialog = false"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-chip v-if="item.status_id === '2'" color="green"
                  ><v-icon left color="green lighten-4">
                    mdi-check-circle </v-icon
                  >{{
                    inlineTranslator({
                      en: pass_result_en.two,
                      th: pass_result_th.two,
                    })
                  }}</v-chip
                >
              </td>
              <td class="greattable" v-html="dt(item.approved_at)"></td>
              <td v-if="is_acl_authorized_officer" class="greattable">
                <v-btn
                  class="primary"
                  @click="goTo(student_id, item.version)"
                  >ตรวจสอบ</v-btn
                >
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="6" class="text-center greattable grey--text">
                {{ $t("english_graduate.no_record") }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="text-center pb-5">
        <v-btn
          class=""
          elevation="2"
          color="success"
          :disabled="cansend === false"
          @click="showform = !showform"
          >{{ $t("english_graduate.open_form") }}</v-btn
        >
      </div></v-card
    >
    <div class="pb-5" v-if="showform === true">
      <v-form v-model="form_validate_status">
        <v-card class="mx-auto mt-2 sborder fwidth" elevation="1"
          ><v-toolbar
            class="mb-6"
            color="light-blue lighten-2"
            elevation="0"
            height="50px"
            ><h2 class="formtext text-left">
              {{ $t("english_graduate.form_title") }}
            </h2></v-toolbar
          ><v-row
            ><v-col cols="12" sm="6" md="6" class="px-6"
              ><h4>{{ $t("english_graduate.select_criteria") }}</h4>
              <v-select
                v-model="study"
                :items="conditions"
                :item-text="
                  (item) =>
                    inlineTranslator({
                      en: item.text_en,
                      th: item.text_th,
                    })
                "
                item-value="study"
                @change="getExamType"
                :rules="requiredRules"
              ></v-select></v-col
            ><v-col cols="12" sm="6" md="6" class="px-6"
              ><h4>{{ $t("english_graduate.select_exam") }}</h4>
              <v-select
                v-model="english_criteria_id"
                :items="all_exam"
                item-text="exam_type"
                item-value="english_criteria_id"
                @change="getEnglishScore"
                :rules="requiredRules"
              ></v-select></v-col></v-row
          ><v-row
            ><v-col cols="12" sm="6" md="6" class="px-6"
              ><h4>{{ $t("english_graduate.score") }}</h4>
              <v-text-field
                v-model="score"
                :disabled="isScoreDisabled"
                :rules="currentRules"
              ></v-text-field></v-col
            ><v-col cols="12" sm="6" md="6" class="px-6"
              ><h4>{{ $t("english_graduate.pass_date") }}</h4>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="isScoreDisabled"
                    :rules="requiredRules"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable :max="today">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col></v-row
          ><v-row
            ><v-col cols="12" sm="6" md="6" class="px-6"
              ><h4>{{ $t("english_graduate.upload") }}</h4>
              <v-file-input
                v-model="file"
                accept="image/png, image/jpeg, image/jpg, application/pdf"
                @change="selectFile"
                @click="clearImagePreview()"
                @click:clear="clearImagePreview"
                label="Select Image or PDF"
                :key="rand"
                :rules="requiredRules"
              >
                <template v-slot:selection="{ file }">
                  <span>{{ file ? file.name : "" }}</span>
                </template></v-file-input
              ></v-col
            ></v-row
          >
          <div v-if="filePreview">
            <v-img v-if="isImage" :src="filePreview" class="preview"></v-img>
            <embed
              v-else
              :src="filePreview"
              width="100%"
              height="800px"
              type="application/pdf"
            />
          </div>
          <div class="text-center">
            <v-btn
              class="my-4"
              color="indigo"
              style="color: white"
              :disabled="isDisabled || submitting"
              :loading="submitting"
              @click="setStudentEnglishSubmission"
              >{{ $t("english_graduate.submit") }}</v-btn
            >
          </div></v-card
        >
      </v-form>
    </div>
  </v-card>
</template>
<script>
import EnglishProvider from "@/services/english.provider.js";
const EnglishService = new EnglishProvider();
import validator from "@/helper/validator";
import { inlineTranslator } from "@/helper/translator";
import {
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
export default {
  name: "EnglishSubmit",

  data: () => ({
    loading: null,
    submitting: false,
    cansend: false,
    showform: false,
    form_validate_status: false,
    study: null,
    english_criteria_id: null,
    isScoreDisabled: false,
    score: null,
    date: null,
    today: new Date().toISOString().substr(0, 10), // Today's date as the maximum allowable date
    file: null,
    filePreview: "",
    isImage: false,
    dialog: false,
    maxSize: {
      image: 4 * 1024 * 1024, // 3 MB
      pdf: 4 * 1024 * 1024, // 4 MB
    },
    admis_year: null,
    admis_term: null,
    level: null,
    level_name_th: null,
    level_name_en: null,
    faculty_name: null,
    faculty_ename: null,
    curr_tname: null,
    curr_ename: null,
    inter_curr: null,
    curr_type: null,
    curr_etype: null,
    e_type_id: null,
    e_type_th: null,
    e_type_en: null,
    e_subject_count: null,
    e_subject_pass: null,
    versions: null,
    record: null,
    study_type_th: {
      zero: "ไม่เรียนวิชาอังกฤษ",
      one: "เรียนวิชาอังกฤษ 1 วิชา",
      two: "เรียนวิชาอังกฤษ 2 วิชา",
    },
    study_type_en: {
      zero: "No English subject",
      one: "Learn 1 English subject",
      two: "Learn 2 English subjects",
    },
    pass_result_th: { one: "รออนุมัติ", two: "ผ่าน", three: "ไม่ผ่าน" },
    pass_result_en: {
      one: "Pending approval",
      two: "Passed",
      three: "Not Passed",
    },
    conditions: [
      {
        text_th: "ไม่เรียนวิชาอังกฤษ",
        text_en: "No English subject",
        study: "0",
      },
      {
        text_th: "เรียนวิชาอังกฤษ 1 วิชา",
        text_en: "Learn 1 English subject",
        study: "1",
      },
      {
        text_th: "เรียนวิชาอังกฤษ 2 วิชา",
        text_en: "Learn 2 English subjects",
        study: "2",
      },
    ],
    all_exam: null,
    requiredRules: [validator.required],
    rand: null,
    selected_score: null,
  }),
  methods: {
    dt,
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      this.loading = true;
      const data = await EnglishService.getEnglishStudentInfo(
        this.student_id
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.admis_year = data.ADMIS_YEAR;
      this.admis_term = data.ADMIS_TERM;
      this.level = data.LEVEL;
      this.level_name_th = data.LEVEL_NAME_TH;
      this.level_name_en = data.LEVEL_NAME_EN;
      this.faculty_name = data.FACULTY_NAME;
      this.faculty_ename = data.FACULTY_ENAME;
      this.curr_tname = data.CURR_TNAME;
      this.curr_ename = data.CURR_ENAME;
      this.inter_curr = data.CURR_TYPE;
      if (data.CURR_TYPE == 0) {
        this.curr_type = "ทั่วไป";
        this.curr_etype = "General";
      } else {
        this.curr_type = "นานาชาติ";
        this.curr_etype = "International";
      }
      if (!data.E_TYPE_ID || data.E_TYPE_ID === null) {
        this.e_type_th = "ยังไม่ผ่าน";
        this.e_type_en = "Not Passed";
      } else {
        this.e_type_id = data.E_TYPE_ID;
        this.e_type_th = data.E_TYPE_TH;
        this.e_type_en = data.E_TYPE_EN;
      }
      if (!data.E_SUBJECT_PASS || data.E_SUBJECT_PASS === null) {
        this.e_subject_pass = "";
      } else {
        this.e_subject_pass = data.E_SUBJECT_PASS;
      }
      this.e_subject_count = data.E_SUBJECT_COUNT;
      if (data.RECORD) {
        this.record = data.RECORD;
        this.versions = this.record[this.record.length - 1].version;
        this.versions = parseInt(this.versions) + 1;
      } else {
        this.record = null;
        this.versions = 1;
      }
      this.cansend = this.checkCanSend;
      await this.$store.dispatch("registration/getYearSemesterNow", this.level);
    },

    getPassColor() {
      if (this.e_type_id == 51 || this.e_type_id == 53) {
        return "blue";
      } else if (
        this.e_type_id == null ||
        !this.e_type_id ||
        this.e_type_id == 99
      ) {
        return "red";
      } else {
        return "green";
      }
    },

    getEnglishLink(value) {
      if (value == "en") {
        return "https://www.reg.kmitl.ac.th/storage/reg/EnglishCriteria_en.pdf";
      } else if (value == "th") {
        return "https://www.reg.kmitl.ac.th/storage/reg/EnglishCriteria_th.pdf";
      } else {
        return "https://www.reg.kmitl.ac.th/storage/reg/EnglishCriteria_en.pdf";
      }
    },

    async getExamType() {
      this.loading = true;
      this.english_criteria_id = null;
      this.all_exam = null;
      this.score = null;
      this.date = null;
      const data = await EnglishService.getExamType(
        this.student_id,
        this.level,
        this.inter_curr,
        this.study
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.all_exam = Object.values(data.ALL_EXAM);
      this.loading = false;
    },

    async getEnglishScore() {
      this.loading = true;
      this.score = null;
      this.date = null;
      if (this.english_criteria_id == 19) {
        this.isScoreDisabled = true;
        this.score = "Not Required";
        this.date = this.today;
        this.currentRules = [];
      } else {
        this.isScoreDisabled = false;
        this.score = null;
      }
      const data = await EnglishService.getEnglishScore(
        this.student_id,
        this.study,
        this.english_criteria_id
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.selected_score = data.SCORE;
      if (!this.selected_score) {
        // If no score is provided, don't set any rules or reset the rules
        this.currentRules = [];
        return;
      }
      if (/^\d+\.\d\+$/.test(this.selected_score)) {
        // Case 1: IELTS single score (e.g., 3.0+, 4.5+)
        const minValue = parseFloat(this.selected_score);
        const ieltsScores = [
          "3",
          "3.5",
          "4",
          "4.5",
          "5",
          "5.5",
          "6",
          "6.5",
          "7",
          "7.5",
          "8",
          "8.5",
          "9",
        ];
        this.currentRules = [
          (v) =>
            (ieltsScores.includes(v) && parseFloat(v) >= minValue) ||
            `Invalid IELTS score, must be at least ${minValue}+`,
        ];
      } else if (/^\d+\+$/.test(this.selected_score)) {
        // Case 2: General numeric threshold (e.g., 513+)
        const minValue = parseInt(this.selected_score);
        this.currentRules = [
          (v) =>
            parseInt(v) >= minValue ||
            `Invalid score, must be at least ${minValue}+`,
        ];
      } else if (/^\d+\.\d-\d+\.\d$/.test(this.selected_score)) {
        // Case 3: IELTS score range (e.g., 3.0-4.0)
        const [start, end] = this.selected_score.split("-").map(parseFloat);
        const ieltsScores = [
          "3",
          "3.5",
          "4",
          "4.5",
          "5",
          "5.5",
          "6",
          "6.5",
          "7",
          "7.5",
          "8",
          "8.5",
          "9",
        ];
        this.currentRules = [
          (v) =>
            (ieltsScores.includes(v) &&
              parseFloat(v) >= start &&
              parseFloat(v) <= end) ||
            `Invalid IELTS score, must be between ${start} and ${end}`,
        ];
      } else if (/^\d+-\d+$/.test(this.selected_score)) {
        // Case 4: General numeric range (e.g., 400-472)
        const [start, end] = this.selected_score.split("-").map(Number);
        this.currentRules = [
          (v) =>
            (parseInt(v) >= start && parseInt(v) <= end) ||
            `Invalid score, must be between ${start} and ${end}`,
        ];
      } else if (/^([A-Z]+\d,?)+$/.test(this.selected_score)) {
        // Case 5: Multiple text-based levels (e.g., B1,B2,C1)
        const levels = this.selected_score.split(",");
        this.currentRules = [
          (v) =>
            levels.includes(v) ||
            `Invalid level, must be one of: ${levels.join(", ")}`,
        ];
      }
      this.loading = false;
    },

    openDialog(item) {
      this.selectedItem = item;
      this.dialog = true;
    },

    selectFile() {
      const file = this.file;
      if (!file) return;
      const isImage = file.type.startsWith("image/");
      const isPdf = file.type === "application/pdf";
      if (
        (isImage && file.size > this.maxSize.image) ||
        (isPdf && file.size > this.maxSize.pdf)
      ) {
        this.$toasted.error(this.$t("toasted.file_size_limit"));
        this.clearImagePreview();
        this.rand = Math.random();
        return;
      }
      this.filePreview = window.URL.createObjectURL(file);
      this.isImage = file.type.startsWith("image/");
    },

    clearImagePreview() {
      if (this.filePreview) {
        window.URL.revokeObjectURL(this.filePreview);
      }
      this.file = null;
      this.filePreview = null;
      this.isImage = false;
    },

    async setStudentEnglishSubmission() {
      if (this.submitting) return;
      this.submitting = true;
      this.loading = true;

      const response = await EnglishService.createStudentEnglishSubmission({
        student_id: this.student_id,
        year: this.year_now,
        semester: this.semester_now,
        study: this.study,
        english_criteria_id: this.english_criteria_id,
        score: this.score,
        pass_date: this.date,
        file: this.file,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.submitting = false;
        this.loading = false;
      });
      if (response && response.status) {
        this.$toasted.success(this.$t("toasted.save_successfully"));
        this.fetch_data();
        this.showform = false;
      } else
        this.$toasted.error(this.$t("toasted.cannot_save"), {
          duration: 0,
        });
      this.submitting = false;
      this.loading = false;
    },

    async goTo(student_id, version_id) {
      const url = this.$router.resolve({
        path: "/english_submit_verify",
        query: { std_id: student_id, version: version_id },
      }).href;
      window.open(url, "_blank");
    },
  },
  computed: {
    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },
    fname_th() {
      return this.$store.state.user.surrogated_student_info.fname_th;
    },
    lname_th() {
      return this.$store.state.user.surrogated_student_info.lname_th;
    },
    fname_en() {
      return this.$store.state.user.surrogated_student_info.fname_en;
    },
    lname_en() {
      return this.$store.state.user.surrogated_student_info.lname_en;
    },
    year_now() {
      return this.$store.state.registration.yearNow;
    },
    semester_now() {
      return this.$store.state.registration.semesterNow;
    },
    admis_year_en() {
      return parseInt(this.admis_year) - 543;
    },
    checkCanSend() {
      const englishTypeId = String(this.e_type_id || "").padStart(2, "0");
      const blockedEnglishTypeIds = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "52",
        "54",
        "91",
        "92",
        "93",
        "94",
        "96",
        "97",
        "98",
      ];

      if (blockedEnglishTypeIds.includes(englishTypeId)) {
        return false;
      }
      if (this.level == 2 && this.e_subject_count >= 2) {
        return false;
      }
      if (!this.record) {
        return true;
      } else {
        const lastRecord = this.record[this.record.length - 1];
        if (
          lastRecord.study === "0" &&
          (lastRecord.status_id === "1" || lastRecord.status_id === "2")
        ) {
          return false;
        } else if (lastRecord.study === "1" && lastRecord.status_id === "1") {
          return false;
        } else if (lastRecord.study === "2" && lastRecord.status_id === "1") {
          return false;
        } else if (
          lastRecord.study === "1" &&
          lastRecord.status_id === "2" &&
          this.e_subject_count >= 1
        ) {
          return false;
        } else if (
          lastRecord.study === "2" &&
          lastRecord.status_id === "2" &&
          this.e_subject_count >= 2
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    isDisabled() {
      return (
        !this.form_validate_status ||
        !this.study ||
        !this.english_criteria_id ||
        !this.score ||
        !this.date ||
        !this.file
      );
    },
    is_acl_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },
  },
  watch: {
    record: {
      handler: function () {
        this.cansend = this.checkCanSend;
      },
      deep: true, // Watch for changes within objects in the array
      immediate: true, // Run the watcher immediately after creation
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
<style scoped>
table.v-simple-table tbody td {
  height: 40px;
  border: none;
}
.theme--light.v-simple-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.preview-container {
  max-height: 70vh;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  overflow: hidden;
}

.preview {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.bborder {
  border: 2px solid #bebebe;
  border-radius: 10px;
}

.tborder {
  background-color: #eee;
}

.sborder {
  border: 1.5px groove #ffffff;
  border-radius: 5px;
  /* background-color: #3a0097; */
}

.ttborder {
  border: 1.5px groove #eb0000;
  border-radius: 0px;
}

.gtext {
  color: #757575;
}

.greattable {
  border: none;
}

.imtext {
  font-size: 24px;
}

.formtext {
  font-size: 22px;
}

.fwidth {
  width: 85%;
}

@media (max-width: 959px) {
  .fwidth {
    width: 95%;
  }
}
</style>
